import React from 'react';
// import './wdyr'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'store/index.js';

import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import App from 'App.js';

// Plugins styles from node_modules
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
// Plugins styles downloaded
import 'assets/vendor/sweetalert2/dist/sweetalert2.min.css';
import 'assets/vendor/select2/dist/css/select2.min.css';
import 'assets/vendor/quill/dist/quill.core.css';
import 'assets/vendor/nucleo/css/nucleo.css';
import 'assets/vendor/@fortawesome/fontawesome-free/css/all.min.css';
// Core styles
import 'assets/scss/argon-dashboard-pro-react.scss?v1.1.0';
import './App.scss';

// Optional scripts
import 'leaflet-control-geocoder/dist/Control.Geocoder.js';

const history = createBrowserHistory();

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
